<template>
<f7-page>
  <f7-navbar>
    <f7-nav-left>
      <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
    </f7-nav-left>
    <f7-link v-on:click="gotprevStep" ><</f7-link>
    <f7-link v-on:click="gotNextStep">></f7-link>

    <f7-nav-right>
      <f7-nav-title> {{currentStepLib}} ({{totalObject}})</f7-nav-title>

      <f7-link icon-if-ios="f7:fullscreen"  icon-if-md="material:fullscreen" v-on:click="toggleFullscreen "></f7-link>
      <f7-link icon-if-ios="f7:menu"  icon-if-md="material:menu" v-on:click="togglePanelRight"></f7-link>
    </f7-nav-right>
  </f7-navbar>

  <div id="logger"></div>
  <div id="selectionInfo">
  <div id="selectionInfoIndex">{{lastSelectedObjectIndex}} <div id="selectionInfoName">{{lastSelectedObjectName}}</div></div>

    {{lastSelectedObjectLib}}
  </div>


  <div id="container3D" v-on:click="kbHide"></div>
  <canvas id="drawing"></canvas>
  <div id="loader" v-bind:class="{isLoading: isLoading }">
    <p>Chargement <span id="loadingIndex">{{totalLoaded}}</span> <span id="totalMesh">{{totalMesh}}</span></p>
  </div>
  <keyboard
  v-if="kbVisible"
  v-model="inputVal"
  @input="changed"
  @ok="kbHide"
  @setIndex="setIndex"
  :layouts="[
    '#1234567890{delete:backspace}|azertyuiop|qsdfghjk|{shift:goto:1}wxcvbn;:!|{index:goto:2}{space:space}{ok:ok}',
      '&é\'(-è_çà)={delete:backspace}|azertyuiop|qsdfghjk|{shift:goto:0}wxcvbn./|{index:goto:2}{space:space}{ok:ok}',
      '{Retour:goto:0}1234567890{delete:backspace}|{MI:setIndex:MI}{M:setIndex:M}{CG:setIndex:CG}{CD:setIndex:CD}{RG:setIndex:RG}{RD:setIndex:RD}{CH ::setIndex:CH}{P:setIndex:P}{T:setIndex:T}{MA:setIndex:MA}{PR:setIndex:PR}{S:setIndex:S}|{ok:ok}'


    ]" ></keyboard>

  <f7-block id="info" theme-dark>


    <f7-page>
        <f7-searchbar
        id="searchItem"
        search-container=".virtual-list"
        search-item="li"
        search-in=".item-title"
        data-layout="normal"
        @searchbar:enable="kbShow"
        @searchbar:disable="kbClose"
        @focus="kbShow"

      ></f7-searchbar>
          <div id="switchLn">
          <f7-link v-on:click="switchLn" data-ln="fr">FR</f7-link>
          <f7-link v-on:click="switchLn" data-ln="pt">PT</f7-link>
          <f7-link v-on:click="switchLn" data-ln="en">EN</f7-link>
        </div>
    <f7-list class="searchbar-not-found">
      <f7-list-item title="Nothing found"></f7-list-item>
    </f7-list>
    <f7-list
    id="itemsList"
      class="searchbar-found"
      media-list
      virtual-list
      :virtual-list-params="{ items, searchAll, renderExternal, height: $theme.ios ? 63 : 73}"
    >
      <ul>
        <f7-list-item
           v-on:click="kbHide"

          v-for="(item, index) in vlData.items"
          :key="index"
          media-item
          link="#"
          :title="item.title"
          :subtitle="item.subtitle"
          :style="`top: ${vlData.topPosition}px`"
          :data-name="item.name"


        ></f7-list-item>
      </ul>
    </f7-list>
  </f7-page>
  </f7-block>

</f7-page>
</template>

<script>
import visionneuse from "../js/visioneuse/visioneuse.js";
import stepsList from "../js/visioneuse/steps.json";


//Keyboard compenent
import keyboard from 'vue-keyboard';
import { serverBus } from '../main';

import nomenclature from "../../static/nomenclature.json"
import nomIndex from "../../static/index.json";

import intialItems from '../../static/export_json/all.json'
//import intialItems from '../../static/export_json/test.json'
var visio;
var selectObj;


export default {
  components: { keyboard },
  data: function() {

    const items = this.setListItem(intialItems);

    var data = {
      showDebug: false,
      locale: 'fr',
      totalMesh: 0,
      totalLoaded: 0,
      isLoading: true,
      nbEtapes: 0,
      currentStep: 0,
      currentStepLib:"initial step",
      totalObject:intialItems.length,
      currentStepListItem :[1,2,3,4],
      lastSelectedObjectName:"",
      lastSelectedObjectLib:"",
      lastSelectedObjectIndex:"",
      items,
      vlData: {
       items: [],
      },
      kbVisible: false,
      layout: "normal",
      input: null,
      inputVal:'',
      options: {
        useKbEvents: false,
        preventClickEvent: false
      }
    }
    return data;
  },
  created(){
    var self = this;

    serverBus.$on('stepChange', (step) => {
      self.currentStep = step;
      self.setStep();
    });
  },
  methods:{
    showObject:function(e){
      var self = this;
      let name = this.$$(e.target).closest('li').data('name');
      this.lastSelectedObjectName = name;

      var objs = visio.getObjects([name]);
      visio.selectObj(objs[0].obj);

      setTimeout(function(){
        let liY = self.$$("#selectionInfo").offset().top - 45;
        let liX = self.$$("#selectionInfo").offset().left;
        visio.startDrawingLineToObj({x:liX, y:liY}, name);
      },50);
    },
    setStep:function() {
      var self = this;
      visio.selectObj(false)

      visio.stopDrawing();
      visio.setObjectsOpacity("all", 1);
      visio.setObjectsColor("all", "reset");
          visio.stopRotation();

      this.lastSelectedObjectName = "";

      var index = self.currentStep;


      if (index == -1){
        // this.currentStepListItem = this.setListItem(intialItems);
        visio.panCam(-1003.27,921.65,-929.41,-2.44,-0.71,-2.64,-16.17,189.24,-58.85);

      }else{
        // this.currentStepListItem = this.setListItem(stepsList[index]);
      }

      this.totalObject = this.currentStepListItem.length;

      // let $itemsList = this.$$('#itemsList');
      // $itemsList[0].f7VirtualList.replaceAllItems(this.currentStepListItem);
      // $itemsList[0].f7VirtualList.update();

      if (index == -1)
        return;

      visio.setObjectsColor(stepsList[index], 0xFF0000);

      if(index > 0)
          visio.setObjectsOpacity(stepsList[index-1], 0.3);

      if(index > 1){
        var transparents = defineTransparentArray(index-2);
        visio.setObjectsOpacity(transparents, 0);
      }

      function defineTransparentArray(step) {
        var i = 0;
        var result = [];
        while (i <= step) {
            result = result.concat(stepsList[i]);
          i++;
        }
        return result;
      }
    },
    searchAll(query, items) {
        const found = [];
        for (let i = 0; i < items.length; i += 1) {
          let foundInTitle = items[i].title.toLowerCase().indexOf(query.toLowerCase()) >= 0;
          let foundInSubTitle = items[i].subtitle.toLowerCase().indexOf(query.toLowerCase()) >= 0;
          if (foundInTitle || foundInSubTitle || query.trim() === '') found.push(i);
        }
        return found; // return array with mathced indexes
    },
    renderExternal(vl, vlData) {
      this.vlData = vlData;
    },
    setListItem: function(newList){
      var items = [];
      var cptNop = 0;
      for (let i in newList){
          let fullName = newList[i].replace('.json', '');

          let name = this.getFolderName(fullName)[1];

          if(this.locale == undefined)
            this.locale = "fr";

          let tName = this.translateName(name, this.locale);
          let tIndex= this.getIndexName(name);
          if(!tIndex)
            cptNop ++;

          items.push({
            title:tIndex,
            subtitle:tName,
            name:fullName
          })
      }
      return items;
    },
    getFolderName:function(name){
      let foldName = "";
      if(name.match(/_/)){
        name = name.split("_");
        foldName = name[0];
        name = name[1];
      }
      return [foldName,name];
    },
    getIndexName:function(name){
      let tIndex=  "";
      if(nomIndex[name] != undefined){
        tIndex = nomIndex[name];
        let tIndexAr = tIndex.match(/([a-zA-Z]+)([0-9]+)/);
        let tNumber = tIndexAr[2];
        let tletter = tIndexAr[1];

        if(tNumber >= 10 && tNumber <= 100)
          tNumber = "0" + tNumber;
        else if(tNumber < 10){
          tNumber = "00" + tNumber;
        }

        tIndex = tletter + tNumber;
      }
        return tIndex.toUpperCase();
    },
    translateName:function(name, lang){
      let words = name.split('-');
      let tName = '';
      for (let y in words){
        let w = words[y];
        let int = w.match(/[0-9]+/);
        if(int)
          w = w.replace(int[0], "");

        if(nomenclature[w] != undefined)
            tName += nomenclature[w][lang] + " ";
        else
            tName += w + " ";

        if(int)
            tName += int[0] + " ";

      }
      return tName;
    },
    switchLn: function(e){
      var li = this.$$(e.target).closest('a');
      var ln = li.data('ln');
      this.locale = ln;
    },
    togglePanelRight:function(e){
      this.$$('#framework7-root').toggleClass('close-panel-right');
      visio.isResising = true;
    },
    toggleFullscreen(e){
      this.$$('#framework7-root').toggleClass('fullscreen');
      if(this.$$('#framework7-root').hasClass('fullscreen')){

        goFullscreen();
      }else{
        exitFullscreen();
      }

      function goFullscreen(){
        var docelem = document.documentElement;
        if (docelem.requestFullscreen) {
            docelem.requestFullscreen();
        }
        else if (docelem.mozRequestFullScreen) {
            docelem.mozRequestFullScreen();
        }
        else if (docelem.webkitRequestFullscreen) {
            docelem.webkitRequestFullscreen();
        }
        else if (docelem.msRequestFullscreen) {
            docelem.msRequestFullscreen();
        }
      }
        function exitFullscreen(){
          var docElm = document;
        if (docElm.exitFullscreen) {
    			docElm.exitFullscreen();
    		} else if (docElm.webkitExitFullscreen) {
            docElm.webkitExitFullscreen();
    		} else if (docElm.mozCancelFullScreen) {
    			docElm.mozCancelFullScreen();
    		} else if (docElm.msExitFullscreen) {
    			docElm.msExitFullscreen();
    		}
          }
    },
    gotNextStep(){
      if(this.currentStep < stepsList.length){
        this.currentStep++;
        this.setStep();
      }
    },
    gotprevStep(){
      if(this.currentStep >= 0){
        this.currentStep--;
        this.setStep();
      }
    },
    kbAccept(text) {
      alert("Input text: " + text);
      this.hide();
    },
    kbShow(e) {
      this.input = e.target;
      this.kbVisible = true;

    },
    kbHide() {
      this.kbVisible = false;
    },
    kbClose(keyboard){
      this.kbHide();
      this.$$('#searchItem')[0].f7Searchbar.disable();
      keyboard.mutate("");
    },
    changed(value) {
     console.log(value);
   },
   setIndex(keyboard, e){
     var args = this.$$(e.originalTarget).data('args');
     var value = keyboard.value;
     console.log(args);

     if(value.match(/([A-Za-z]+)([0-9]+)/)){
       console.log(value.replace(/([A-Za-z]+)([0-9]+)/,args+'$2'));
       keyboard.mutate(value.replace(/([A-Za-z]+)([0-9]+)/,args+'$2'))
     }else {
       keyboard.mutate(args)
     }
     console.log(value);
   }
  },
  watch:{
    inputVal(){
      this.$$('#info input').val(this.inputVal).trigger('change')
    },
    currentStep(){
      if(this.currentStep < 0)
        this.currentStepLib = "initial step"
      else {
          this.currentStepLib = "step " + (parseInt(this.currentStep)+1);
      }
    },
    lastSelectedObjectName(){
      if(this.lastSelectedObjectName ==""){
        this.lastSelectedObjectLib ="";
        this.lastSelectedObjectIndex = "";
      }else{
        let name = this.getFolderName(this.lastSelectedObjectName)[1];
        this.lastSelectedObjectLib = this.translateName(name, this.locale);
        this.lastSelectedObjectIndex= this.getIndexName(name);
      }
    },
    locale(){
      this.setStep();
      if(this.lastSelectedObjectName ==""){
        this.lastSelectedObjectLib ="";
        this.lastSelectedObjectIndex = "";
      }else{
        let name = this.getFolderName(this.lastSelectedObjectName)[1];
        this.lastSelectedObjectLib = this.translateName(name, this.locale);
        this.lastSelectedObjectIndex= this.getIndexName(name);
      }
    }
  },
  mounted: function() {
    var self = this;

        // this.$$('#info input').data("layout", "normal")
    // return;
    this.$$('#info input').attr('readonly', 'readonly');
    this.$$('#info input').on('touchstart', function(e){
      // console.log('touch start');
      self.$$('#searchItem')[0].f7Searchbar.enable();
      return false;
    })
    // this.$$('#info input').on('click', function(){
    //   self.$$('#info input').removeAttr('readonly');
    // })


    this.currentStep = -1;
    this.$$('#framework7-root').toggleClass('close-panel-right');

    visio = new visionneuse({
      'containerId': 'container3D',
      'loadingFilesName': ["all"],
      //'loadingFilesName': ["test"],
      'geometries': ["all"],
      'explodedGeometries': ["all"],
      'drawingCanvasId':'drawing',
      'dom7': self.$$,
      group: false,
      'afterLoadNextShape': function(totalMesh, totalLoaded) {
        self.totalMesh = totalMesh;
        self.totalLoaded = totalLoaded;
        if (totalMesh == totalLoaded) {
          self.isLoading = false;
          self.$$('#app').addClass('loaded');
        }
      },
      'onObjectClick':function(intersects){

        var i =0;
        var obj = null;
        do{
          var obj = intersects[i].object;
          i++;
        }while(obj.material.opacity ==0 && i < intersects.length);

        if(obj.material.opacity == 0)
          return;
        self.lastSelectedObjectName = obj.name;
        visio.selectObj(obj)
        visio.stopDrawing();

        setTimeout(function(){
          let liY = self.$$("#selectionInfo").offset().top - 45;
          let liX = self.$$("#selectionInfo").offset().left;

          visio.startDrawingLineToObj({x:liX, y:liY}, obj.name);
        },50)

      }
    });

    this.$$(document).on('click', '#info li', this.showObject)



  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home.vue